<script lang="ts">
	import { Select } from '../../../../../../components/Select';
	import type { FilterSortOption } from '../../../../types';
	import { applyFilters } from '../../../../utils/applyFilters/applyFilters';
	import { page } from '$app/state';

	interface Props {
		options: FilterSortOption[];
		sortIndex?: number | undefined;
		retainSearchParams?: boolean | undefined;
		scrollTarget?: string;
	}

	let {
		options,
		sortIndex = 0,
		retainSearchParams = undefined,
		scrollTarget = undefined
	}: Props = $props();

	let dataCy = $derived(`filter-sort-${sortIndex}`);
	let name = $derived(`sort${sortIndex}`);
	const ariaLabel = `Sort by`;

	// eslint-disable-next-line @typescript-eslint/no-explicit-any
	let searchParams = $derived((page as any).url.searchParams);
	let value = $derived(searchParams.get(`sort${sortIndex}`) || options[0].value);

	const handleChange = ({ detail: { value } }: { detail: { value: string } }) => {
		applyFilters({
			sort: {
				[`sort${sortIndex}`]: value
			},
			retainSearchParams,
			scrollTarget
		});
	};

	let modifiedOptions = $derived(
		options.map(({ value, label }) => ({
			value,
			label: label.toUpperCase()
		}))
	);
</script>

<Select
	selectedPrefix="SORT:"
	class="w-full"
	{dataCy}
	{name}
	{ariaLabel}
	options={modifiedOptions}
	{value}
	onchange={handleChange}
	classes={{
		placeholder: 'font-medium tracking-widest'
	}}
/>
